import React from 'react';
const items = [<>
    <strong className="font-bold" data-id="element-109">Cómo Crear videos UGC auténticos</strong> y
    que generan CIENTOS de ventas 💸💸
  </>, <>
    <strong className="font-bold" data-id="element-110">Cómo grabar, editar y estructurar</strong>{' '}
    <em data-id="element-111">tus videos como una Creadora PRO</em>
  </>, <>
    <strong className="font-bold" data-id="element-112">Cómo armar tu portfolio profesional</strong>{' '}
    <em data-id="element-113">con mis plantillas</em>
  </>, <>
    <strong className="font-bold" data-id="element-114">Cómo trabajar con marcas</strong>{' '}
    <em data-id="element-115">sin experiencia ni miles de seguidores</em>
  </>];
export function LearnSection() {
  return <section className="px-6 py-10 flex flex-col items-center text-center" data-id="element-116">
      <div className="w-full max-w-5xl bg-white rounded-[2.5rem] p-8 md:p-16 shadow-sm border border-white/50" data-id="element-117">
        <h2 className="font-serif text-3xl md:text-5xl text-brand-navy mb-10" data-id="element-118">
          ¿Qué vas a aprender?
        </h2>

        <ol className="w-full grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-7 text-left" data-id="element-119">
          {items.map((item, i) => <li key={i} className="font-serif text-[19px] md:text-[22px] text-brand-navy leading-snug" data-id="element-120">
              <span className="font-bold" data-id="element-121">{i + 1}.</span> {item}
            </li>)}
        </ol>
      </div>
    </section>;
}